<script>
export default {
	props: ["progress", "isAnimated", "isDouble", "href1", "href2"],
	setup() {
		const goAnchor = (id, e) => {
			e.preventDefault();
			const anchor = document.querySelector(id);
			const top = anchor.getBoundingClientRect().top;
			// chrome
			document.body.scrollTop = document.body.scrollTop + top;
			// firefox
			document.documentElement.scrollTop =
				document.documentElement.scrollTop + top;
			// safari
			window.pageYOffset = window.pageYOffset + top;
		};

		return {
			// goAnchor,
		};
	},
};
</script>

<template>
	<div class="CTA-button">
		<transition name="fade">
			<a class="single" v-show="!isDouble" :href="`${href1 || ''}`">
				<span class="text_ch_medium"><slot></slot></span>
			</a>
		</transition>
		<transition name="fade">
			<a
				class="double"
				v-show="isDouble"
				:href="`${href1 || ''}`"
				target="_blank"
			>
				<span class="text_ch_medium">瞭解更多</span>
			</a>
		</transition>
		<transition name="fade">
			<span class="seperator" v-show="isDouble">|</span>
		</transition>
		<transition name="fade">
			<a class="double" v-show="isDouble" :href="`${href2 || ''}`">
				<span class="text_ch_medium">預約賞車</span>
			</a>
		</transition>
		<div class="border left"></div>
		<div class="border right"></div>
		<div class="border bottom"></div>
		<div class="button_border-bottom"></div>
		<div
			:class="[
				'button_border-bottom',
				'pgBar',
				{ isAnimated: isAnimated },
			]"
			:style="{ width: `${progress}%` }"
		></div>
	</div>
</template>

<style lang="sass">
.CTA-button
    position: absolute
    bottom: calc(3.125vw + 6px)
    width: calc(10.5vw + 199.2px)
    height: calc(1.4vw + 31.6px)
    background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.3) 50%, rgba(#ffe8c9, 0.6))
    z-index: 1000
    .single, .double
        display: inline-block
        position: absolute
        width: 100%
        height: 100%
        left: 0
        top: 0
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25)
        font-size: 1.5rem
        line-height: calc(1.4vw + 31.6px)
        letter-spacing: 3.15px
        text-align: center
        user-select: none
        cursor: pointer
        text-decoration: none
        &:hover
            background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.45) 50%, rgba(#ffe8c9, 0.75))
        &:active
            background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.45) 50%, rgba(#ffe8c9, 0.75))
    .double
        width: 50%
    .double:nth-child(4)
        left: 50%
    span
        height: 100%
        font-size: inherit
        &.seperator
            position: absolute
            left: 50%
            top: 50%
            transform: translate(-50%, -50%)
            text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6)
            font-size: 1.5rem
            line-height: calc(1.4vw + 31.6px)
            letter-spacing: 3.15px
            text-align: center
    .border
        position: absolute
        width: 1px
        height: calc(1.4vw + 31.6px)
        opacity: 0.5
        background: linear-gradient(to bottom, rgba(#fff, 0), #c1c1c1)
        &.left
            left: 0
            top: 0
        &.right
            right: 0
            top: 0
        &.bottom
            height: 1px
            width: calc(10.5vw + 199.2px)
            bottom: 0
            background: none
            background-color: #c1c1c1
    .button_border-bottom
        position: absolute
        top: 100%
        width: calc(10.5vw + 199.2px)
        height: 6px
        background-image: linear-gradient(to right, #8e3636 11%, #6c1524 38%, #0653b6 91%)
        opacity: 0.5
        &.pgBar
            opacity: 1
            width: 100%
            background-repeat: repeat-x
            background-position: 0 0
            background-image: url("~@/assets/color-bar.png")
            animation: color-bar-loop 1s linear infinite forwards
            background-size: cover
        &.isAnimated
            transition: 1s linear

.fade-enter-active, .fade-leave-active
    transition: opacity 0.3s ease
.fade-enter-from, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave-from
    transition-delay: 0.3s
    opacity: 1

@keyframes color-bar-loop
    0%
        background-position: 0 0
    100%
        background-position: calc(10.5vw + 199.2px) 0

@media screen and (max-width: 768px)
    .CTA-button
        bottom: 75px
        .single, .double
            font-size: 1.2rem
            letter-spacing: 1.8px
            span
                &.seperator
                    font-size: 1.3rem
                    letter-spacing: 1.8px
        .border
            width: 0.5px
            &.bottom
                height: 0.5px
        .button_border-bottom
            height: 3px
</style>
